// What the signed-in user may do (D51): `GET /api/me` returns their role and effective
// permissions; the UI hides what they cannot use. The API checks every admin route itself,
// so this is presentation only.
import { queryOptions, useQuery } from "@tanstack/react-query";

import { api, type Schemas } from "../api/client";
import { unwrap } from "../api/queries";

export type Me = Schemas["MeDto"];

/** A permission's PascalCase name, as `/api/me` and `/api/admin/permissions` spell it. */
export type PermissionName = string;

export const accessQuery = () =>
  queryOptions({
    queryKey: ["me", "access"],
    queryFn: () => unwrap(api.GET("/api/me")),
    retry: false,
    staleTime: 60_000,
  });

export function can(me: Me | undefined, permission: PermissionName): boolean {
  return me?.permissions.includes(permission) ?? false;
}

/** Whether the signed-in user holds `permission`; false while loading. */
export function useCan(permission: PermissionName): boolean {
  const me = useQuery(accessQuery());
  return can(me.data, permission);
}
